import React, { useRef } from 'react';
import Button from 'components/Button';
import styled from 'styled-components';
import LeftCustomerDetailsContent from './LeftCustomerDetailsContent';
import RightCustomerDetailsContent from './RightCustomerDetailsContent';
import ModalConfirm, { useModalConfirmRef } from 'components/Modal/ModalConfirm';
import customerSelectors from 'features/customer/services/selectors';
import apis from 'features/customer/services/apis';
import toast from 'utils/toast';
import CreateOrUpdateCustomer, { CreateOrUpdateCustomerRef } from './CreateOrUpdateCustomer';
import customerActions from 'features/customer/services/actions';
import { useAppDispatch } from 'store/hooks';
import Text from 'components/Text';
import PermissionManager from 'widgets/PermissionVerify';
type DetailsCustomerModalContainerProps = {
  onClose: () => void;
};

const DetailsCustomerModalContainer = ({ onClose }: DetailsCustomerModalContainerProps) => {
  const dispatch = useAppDispatch();
  const modalConfirm = useModalConfirmRef();
  const createOrUpdateCustomerRef = useRef<CreateOrUpdateCustomerRef>(null);
  const customerDetails = customerSelectors.getCustomerDetails();

  const handleDeleteCustomer = async () => {
    const callback = () => modalConfirm.current?.open(`Do you want to remove ${customerDetails?.name || 'haha'}?`, async () => {
      try {
        const resData = await apis.deleteCustomer(customerDetails?.id);
        if (resData?.data?.data) {
          toast.success('Delete customer successfully!');
          dispatch(customerActions.deleteCustomer.success(resData.data.data));
          dispatch(customerActions.getCustomersActive.fetch({}));
          dispatch(customerActions.setCustomerParam({}));
          onClose();
        } else {
          toast.error('Delete customer failed!');
        }
      } catch (error) {
        toast.error('Delete customer failed!');
      }
    });
    const result = await PermissionManager.verify(PermissionManager.PERMISSIONS.CUSTOMER_DELETE);
    if (!result || result?.skip) return callback();
    if (!result.verifyData) return;
    callback();
  };

  const handleEditCustomer = async () => {
    const result = await PermissionManager.verify(PermissionManager.PERMISSIONS.CUSTOMER_EDIT);
    if (!result || result?.skip) return createOrUpdateCustomerRef.current?.onOpen(customerDetails);
    if (!result.verifyData) return;
    createOrUpdateCustomerRef.current?.onOpen(customerDetails);
  };

  const handleEditCustomerSuccess = () => {
    dispatch(customerActions.getCustomerDetails.fetch(customerDetails?.id || ''));
    dispatch(customerActions.setCustomerParam({}));
  };

  return (
    <ContainerStyled>
      <BodyStyled>
        <LeftCustomerDetailsContent />
        <RightCustomerDetailsContent />
      </BodyStyled>

      <ButtonGroupStyled>
        <Button ntype='SECONDARY' onClick={onClose} block>
          <Text variant='H7'>Close</Text>
        </Button>
        <Button ntype='DANGER' onClick={handleDeleteCustomer} block>
          <Text variant='H7'>Delete</Text>
        </Button>
        <Button ntype='DARK_BLUE' block onClick={handleEditCustomer}>
          <Text variant='H7' color='text_1'>
            Edit
          </Text>
        </Button>
      </ButtonGroupStyled>
      <ModalConfirm ref={modalConfirm} />
      <CreateOrUpdateCustomer
        ref={createOrUpdateCustomerRef}
        onSuccess={handleEditCustomerSuccess}
      />
    </ContainerStyled>
  );
};

export default DetailsCustomerModalContainer;

const ContainerStyled = styled.div`
  position: relative;
  background-color: #fff;
`;

const ButtonGroupStyled = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  gap: 16px;
  background: #fff;
  padding: 16px 16px 24px 16px;
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.15);
`;

const BodyStyled = styled.div`
  height: calc(90vh - 96px);
  display: flex;
  gap: 8px;
`;
